/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import { Injectable } from '@angular/core';

// The board list a project was opened from, so the project page can offer Previous / Next through it.
// The Angular side of the AngularJS $rootScope.navigatePrevNext.project.
@Injectable({ providedIn: 'root' })
export class ProjectNavigationService {
  feed: any = null;
}
